// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ohhJVM{display:flex;align-items:center;font-size:16px;line-height:1;transform:translateX(1px)}.ohhJVM:after{content:attr(data-label)}div[data-vod-player-max-width~="1900px"] .ohhJVM{font-size:12px}div[data-vod-player-max-width~="400px"] .ohhJVM[data-short-label]:after{content:attr(data-short-label)}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ohhJVM`
};
export default ___CSS_LOADER_EXPORT___;
